module.exports = __webpack_public_path__ + "img/case-logo-35.52ab338a.png";